module.exports = __webpack_public_path__ + "img/readpower.48fc6605.png";